export default __webpack_public_path__ + "static/media/hotel_img_jp_11.cd809f29.jpg";